import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import {
  guideContentDE,
  guideContentEN,
  guideContentES,
  guideContentFR,
  guideContentIT,
  guideContentPT,
  guideContentRO
} from './locales/guideContent';
import {
  adminContentDE,
  adminContentEN,
  adminContentES,
  adminContentFR,
  adminContentIT,
  adminContentPT,
  adminContentRO
} from './locales/adminContent';
import {
  navContentDE, navContentEN, navContentES, navContentFR, navContentIT, navContentPT, navContentRO
} from './locales/navContent';
import en from './locales/en';
import de from './locales/de';
import es from './locales/es';
import fr from './locales/fr';
import it from './locales/it';
import pt from './locales/pt';
import ro from './locales/ro';

const resources = {
  en: { translation: { ...en, ...guideContentEN, ...adminContentEN, ...navContentEN } },
  de: { translation: { ...de, ...guideContentDE, ...adminContentDE, ...navContentDE } },
  es: { translation: { ...es, ...guideContentES, ...adminContentES, ...navContentES } },
  fr: { translation: { ...fr, ...guideContentFR, ...adminContentFR, ...navContentFR } },
  it: { translation: { ...it, ...guideContentIT, ...adminContentIT, ...navContentIT } },
  pt: { translation: { ...pt, ...guideContentPT, ...adminContentPT, ...navContentPT } },
  ro: { translation: { ...ro, ...guideContentRO, ...adminContentRO, ...navContentRO } }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    supportedLngs: ['en', 'de', 'es', 'fr', 'it', 'pt', 'ro'],
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
      convertDetectedLanguage: (lng) => {
        // Map browser locales like 'de-DE' -> 'de', 'en-US' -> 'en'
        const base = lng.split('-')[0].toLowerCase();
        const supported = ['en', 'de', 'es', 'fr', 'it', 'pt', 'ro'];
        return supported.includes(base) ? base : 'en';
      }
    }
  });

export default i18n;
